'use es6';

import { LAYOUT_SECTION_COLUMNS_RESIZED, LAYOUT_SECTION_ROW_CLONED_BELOW, LAYOUT_SECTION_CELL_CLONED_TO_RIGHT, SET_IS_INLINE_FIELD_FOCUSED } from 'ContentEditorUI/redux/actions/actionTypes';
import actionTypes from 'InpageEditorUI/redux/actions/actionTypes';
import { revertToPreviousSelection, clearSelectedItem } from 'ContentEditorUI/redux/actions/selectionActions';
import { createAddToLayoutAction } from 'InpageEditorUI/lib/layoutSection/createAddToLayoutAction';
import { getSelectedItemId } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { Iterable } from 'immutable';
export const draggingStarted = dragItem => ({
  iframeOnly: true,
  type: actionTypes.LAYOUT_SECTION_DRAGGING_STARTED,
  payload: {
    dragItem
  }
});
export const draggingStartedAndDeselectExisting = dragItem => (dispatch, getState) => {
  const reduxState = getState();
  const selectedId = getSelectedItemId(reduxState);

  // Deselect currently selected module on drag
  if (selectedId) {
    dispatch(clearSelectedItem());
    dragItem.hadSelectionBeforeDrag = !!selectedId;
  }
  dispatch(draggingStarted(dragItem));
};
export const draggingStopped = () => ({
  iframeOnly: true,
  type: actionTypes.LAYOUT_SECTION_DRAGGING_STOPPED
});
export const draggingStoppedAndReselectIfNeeded = (dragItem, dropSucceeded) => dispatch => {
  // Reselect previously selected item on canceled drag
  if (!dropSucceeded && dragItem && dragItem.hadSelectionBeforeDrag) {
    dispatch(revertToPreviousSelection());
  }
  dispatch(draggingStopped());
};
export const mouseCoordsAtDropUpdated = mouseCoordsAtDrop => ({
  iframeOnly: true,
  type: actionTypes.LAYOUT_SECTION_DROP_COORDS_UPDATED,
  payload: {
    mouseCoordsAtDrop
  }
});
export const droppedOnLayoutSection = ({
  contentType,
  existingColumnId,
  existingRowId,
  existingNodeId,
  originLayoutSectionId,
  parentId
}, dropTarget, layoutSectionId) => {
  if (!dropTarget) {
    console.log('Dropped, but ignoring since there was no drop target');
    return null;
  }
  const dropTargetPayloadSource = Iterable.isIterable(dropTarget) ? dropTarget.toJS() : dropTarget;
  const {
    type,
    payload
  } = createAddToLayoutAction(dropTargetPayloadSource);
  const modifiedPayload = Object.assign({
    layoutSectionId,
    gridLayoutId: layoutSectionId,
    contentType,
    originLayoutSectionId,
    existingRowId,
    existingColumnId,
    existingNodeId,
    parentId
  }, payload);
  return {
    iframeOnly: false,
    type,
    payload: modifiedPayload,
    // Helpful info for iframe layout section DnD reducer since the original info gets lost
    originalActionToPassThrough: {
      type,
      payload: modifiedPayload
    }
  };
};
export const layoutSectionHoverPositionsCleared = () => ({
  iframeOnly: true,
  type: actionTypes.LAYOUT_SECTION_HOVER_POSITIONS_CLEARED
});
export const layoutSectionHoverPositionsUpdated = hoverPositions => ({
  iframeOnly: true,
  type: actionTypes.LAYOUT_SECTION_HOVER_POSITIONS_UPDATED,
  payload: {
    hoverPositions
  }
});
export const layoutSectionNodePositionsUpdated = (nodePositions, bodyOffset) => ({
  iframeOnly: true,
  type: actionTypes.LAYOUT_SECTION_NODE_POSITIONS_UPDATED,
  payload: {
    nodePositions,
    bodyOffset
  }
});
export const layoutSectionNodePositionsCleared = () => ({
  iframeOnly: true,
  type: actionTypes.LAYOUT_SECTION_NODE_POSITIONS_CLEARED
});
export const layoutSectionNodePositionsRefreshedButUnchanged = () => ({
  iframeOnly: true,
  type: actionTypes.LAYOUT_SECTION_NODE_POSITIONS_REFRESHED_BUT_UNCHANGED
});
export const hoveredDragHandleUpdated = (handleType, handleId) => ({
  iframeOnly: true,
  type: actionTypes.LAYOUT_SECTION_HOVERED_DRAG_HANDLE_UPDATED,
  payload: {
    handleType,
    handleId
  }
});
export const mouseLeftIFrame = () => ({
  iframeOnly: true,
  type: actionTypes.LAYOUT_SECTION_MOUSE_LEFT_IFRAME
});
export const mouseEnteredIFrame = () => ({
  iframeOnly: true,
  type: actionTypes.LAYOUT_SECTION_MOUSE_ENTERED_IFRAME
});
export const iframeScrollPositionChanged = ({
  left,
  top
}) => ({
  iframeOnly: true,
  type: actionTypes.LAYOUT_SECTION_SCROLL_POSITION_CHANGED,
  payload: {
    left,
    top
  }
});
export const layoutSectionDragItemIsHiddenUpdated = dragItemIsHidden => {
  return {
    iframeOnly: true,
    type: actionTypes.LAYOUT_SECTION_DRAG_ITEM_IS_HIDDEN_UPDATED,
    payload: {
      dragItemIsHidden
    }
  };
};
export const dragHandlesBlurred = () => ({
  iframeOnly: true,
  type: actionTypes.LAYOUT_SECTION_DRAG_HANDLES_BLURRED
});
export const layoutSectionToolbarMeasured = ({
  name,
  size,
  width,
  height
}) => {
  return {
    iframeOnly: true,
    type: actionTypes.LAYOUT_SECTION_TOOLBAR_MEASURED,
    payload: {
      name,
      size,
      width,
      height
    }
  };
};
export const layoutSectionHoverPositionsFrozen = () => ({
  iframeOnly: true,
  type: actionTypes.LAYOUT_SECTION_HOVER_POSITIONS_FROZEN
});
export const layoutSectionHoverPositionsClearedAndFrozen = () => ({
  iframeOnly: true,
  type: actionTypes.LAYOUT_SECTION_HOVER_POSITIONS_CLEARED,
  payload: {
    alsoFreeze: true
  }
});
export const layoutSectionHoverPositionsThawed = () => ({
  iframeOnly: true,
  type: actionTypes.LAYOUT_SECTION_HOVER_POSITIONS_THAWED
});
export const layoutSectionColumnsResized = (layoutSectionId, {
  leftColumnInfo,
  rightColumnInfo
}) => {
  const type = LAYOUT_SECTION_COLUMNS_RESIZED;
  const payload = {
    layoutSectionId,
    leftColumnInfo,
    rightColumnInfo
  };
  return {
    iframeOnly: false,
    type,
    payload,
    undoData: {
      groupKey: leftColumnInfo.id
    },
    // Helpful info for iframe layout section DnD reducer since the original info gets lost
    originalActionToPassThrough: {
      type,
      payload
    }
  };
};
export const layoutSectionRowClonedBelow = (layoutSectionId, rowId) => {
  const type = LAYOUT_SECTION_ROW_CLONED_BELOW;
  const payload = {
    rowId,
    layoutSectionId
  };
  return {
    iframeOnly: false,
    type,
    payload,
    originalActionToPassThrough: {
      type,
      payload
    }
  };
};
export const layoutSectionCellClonedToRight = (layoutSectionId, cellId) => {
  const type = LAYOUT_SECTION_CELL_CLONED_TO_RIGHT;
  const payload = {
    cellId,
    layoutSectionId
  };
  return {
    iframeOnly: false,
    type,
    payload,
    originalActionToPassThrough: {
      type,
      payload
    }
  };
};
export const setIsInlineEditableFieldFocused = value => {
  return {
    iframeOnly: true,
    type: SET_IS_INLINE_FIELD_FOCUSED,
    payload: value
  };
};